var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3L5.68377 1.43874C6.3313 1.2229 7 1.70487 7 2.38743V3L13 1V9L8.31623 10.5613C7.6687 10.7771 7 10.2951 7 9.61257V9L1 11V3Z",
    fill: "#99FFDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17V11M7 9V3M7 9L1 11M7 9V9.61257C7 10.2951 7.6687 10.7771 8.31623 10.5613L13 9V1L7 3M7 3V2.38743C7 1.70487 6.3313 1.2229 5.68377 1.43874L1 3V11",
    stroke: "#0A255C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSide);
export default __webpack_public_path__ + "static/media/Side.82dea5fc375af1a5566f6c26c58c3381.svg";
export { ForwardRef as ReactComponent };